import React, {Component} from 'react';
import '../styles/job-list/index';

class JobIntro extends Component {
    render() {
        return (
            <div className="careerfy-main-section careerfy-parallex-full">
                <div className="container">
                    <div className="row">
                        <aside className="col-md-6 careerfy-typo-wrap">
                            <div className="careerfy-parallex-text">
                                <h2>What’s it like working at DevStack?</h2>
                                <p>At DevStack, we are open, nurturing, collaborative, balanced and innovative. You can be just who you are. No prejudice, no bigotry. We appreciate diversity in our culture which reflected in the way DevStack do its business — around the globe and with people from different background.  .</p>
                            </div>
                        </aside>
                        <aside className="col-md-6 careerfy-typo-wrap"> 
                            <div className="careerfy-right">
                                <img src="https://cdn.techinasia.com/data/images/xuFjQxSPXGgykLdGuGx3lJ67yTntMfLRDVFsjDzE.png" alt="" />
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        )
    }
};

export default JobIntro;


// WEBPACK FOOTER //
// ./src/components/JobIntro.js